var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { EXPERIMENT_DETAILS_PAGE_ALERT_REDUCER } from "@ane/exp-data/lib/constants/ReducerConstants";
import { moduleReducer } from "@ane/exptemplate/lib/module/reducers";
import "./views/Create/ducks/CreateExpDucks.js";
import { getAlertReducer } from "@ane/expalert/lib/module/reducers";
import currentUserDetailsReducersMapObject from "@ane/exp-data/lib/userDetails/CurrentUserDetailsReducer";
import { DetailsViewReducer } from "./views/Details/ducks/DetailsViewReducer.js";
import { experimentCreateReducer } from "./views/Create/components/ExperimentCreateContainer/ExperimentCreateContainer.ducks.js";
const experimentReducers = __spreadProps(__spreadValues({}, currentUserDetailsReducersMapObject), {
  details: DetailsViewReducer,
  createExp: experimentCreateReducer,
  templateSelectionModule: moduleReducer.templateSelectionModule,
  [`${EXPERIMENT_DETAILS_PAGE_ALERT_REDUCER}`]: getAlertReducer(EXPERIMENT_DETAILS_PAGE_ALERT_REDUCER)
});
export {
  experimentReducers as default,
  experimentReducers
};
//# sourceMappingURL=reducers.js.map
